import React, { useCallback } from 'react';
import { Link } from 'react-router';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';

const ContactUs = ({ router, popoverRef, buttonText = '' }) => {
  const { pushParamsToHistory } = useNavigation({
    router,
  });

  const onClick = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();
      if (popoverRef && popoverRef.current) {
        popoverRef.current.close();
      }
      pushParamsToHistory({
        contactus: 'show',
      });
    },
    [pushParamsToHistory],
  );

  return (
    <>
      <h4 className="flex items-center m-0 bg-gray-100 pt-4.2 pb-0.9 pl-8 border-b border-gray-300 uppercase text-black text-14 font-medium">
        Contact us about an issue
      </h4>
      <ul className="list-none p-0 m-0">
        <li className="list-none pt-8.1 pb-4.8 pl-16.6 pr-8.5">
          <A11y>
            <Link
              tabIndex={0}
              onClick={onClick}
              className="text-blue-800 text-16 font-normal"
            >
              {buttonText}
            </Link>
          </A11y>
        </li>
      </ul>
    </>
  );
};

export default ContactUs;
